import React from "react";
import Header from "../../components/HeaderNew";
import { Button } from "@material-ui/core";
import Footer from "../FooterNew";
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Helmet } from "react-helmet";

import { Section } from "react-scroll-section";
import NewHead from "../landing/NewHead";
import ServiceFooter from "../ServiceFooter";
function Cex() {
  const processes_feture = {
    arrows: true,
    dots: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 3,
          infinite: true,
          dots: false,
          arrow: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },

      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          dots: false,
          autoplay: true,
          arrow: false,
          autoplaySpeed: 2000,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1,
          arrow: false,
          dots: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },
    ],
  };
  return (
    <main className="">
      <header>
        {/* <Header /> */}
        <NewHead />
      </header>
      <Helmet>
        <title>
          Central Bank Digital Currency Development Company - Beleaf
          Technologies
        </title>

        <meta
          name="title"
          content="Central Bank Digital Currency Development Company"
        />
        <meta
          name="description"
          content=" Levelup your financial ecosystem with our Central Bank Digital Currency development expertise. As a leading company, we specialize in creating secure and scalable CBDC solutions developed to your needs. Trust us to navigate the digital currency landscape and shape the future of your central bank's digital presence."
        />

        <meta
          property="og:title"
          content="Central Bank Digital Currency Development Company - Beleaf Technologies"
        />
        <meta property="og:site_name" content="Beleaf Technologies" />

        <link
          rel="canonical"
          href="https://www.beleaftechnologies.com/central-bank-digital-currency-development-company"
        />
      </Helmet>
      <main className="dungeonswap_main ">
        <section className="dungeonswap_bannersec d-flex align-items-center">
          <div className="container">
            <div className="row">
              <div className="col-lg-5 d-flex align-items-center"></div>
              <div className="col-lg-7 d-flex align-items-center">
                <div className="dungeonswap_bannersec_content d-flex flex-column">
                  <h1 className="mb-0">
                    <span className="dungeonswap_span">DungeonSwap</span> Clone
                    Script
                    <br />
                    Development Company
                  </h1>
                  <p className="mb-0 dungeonswap_p ">
                    Beleaf Technologies your gateway to advanced DungeonSwap
                    Clone Script Development! Get into the world of
                    decentralized finance (DeFi-RPG) gaming with our expert
                    solutions developed for your unique needs.
                  </p>
                  <Button
                    data-toggle="modal"
                    data-target="#myModal"
                    aria-label="Contact Us"
                    className="dungeonswap_button"
                  >
                    Lets Discuss
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="dungeonswap_whatissec d-flex align-items-center bg-white">
          <div className="container">
            <div className="row ">
              <div className="col-lg-6">
                <div className="dungeonswap_whatissec_content d-flex flex-column ">
                  <h2 className="dungeonswap_h2 mb-0">
                    What is{" "}
                    <span className="dungeonswap_span">DungeonSwap</span> Clone
                    Script Development?
                  </h2>
                  <p className="mb-0 dungeonswap_p ">
                    DungeonSwap Clone Script Development is the process of
                    replicating the features and functionalities of the
                    popularDefi RPG game DungeonSwap, a decentralized finance
                    (DeFi) project that integrates yield farming, decentralized
                    exchange (DEX), and non-fungible token (NFT) capabilities.
                    Liquidity pools , Stacking like the original DungeonSwap
                    gaming platform. This clone script empowers entrepreneurs to
                    launch their own DeFi gaming platforms with similar
                    attributes, enabling financial inclusivity and innovation.
                  </p>
                  <a href="/contact-us" className="">
                    <button className="dungeonswap_button">
                      Talk To Our Experts
                    </button>
                  </a>
                </div>
              </div>
              <div className="col-lg-6 d-flex align-items-center"></div>
            </div>
          </div>
        </section>
      </main>
      {/* <Footer /> */}
      <ServiceFooter />
    </main>
  );
}

export default Cex;
